import ScrollIndicator from './ScrollIndicator';

export default ScrollIndicator;
